(() => {
    const materialInputs = document.querySelectorAll('.input-material') 

    materialInputs.forEach(function(materialInput) {
        const label = materialInput.querySelector('label')
        const input = materialInput.querySelector('input')
        input.addEventListener('focus', handleActions({label, input}))
        input.addEventListener('blur', handleActions({label, input}))
        
        function handleActions(elements) {
            const {label, input} = elements
            return function(e) {
                const eventType = e.type;

                switch (eventType) {
                    case "focus":
                        label.classList.add('active')
                        return
                    case "blur":
                        if(input.value === "") {
                            label.classList.remove("active")
                        }
                        return
                    default:
                        return;
                }
            }
        }
    })
})();